import React, { useState, useEffect } from "react";
import {
    Logo,
    BottomCenteringContainer,
    TableFlexContainer,
    LeftFlexGrow,
    RightFlexGrow,
    TableContainer,
    BoldDescriptionText,
    MainContainer,
    CenteringContainer,
    StyledTitle,
    SpaceBetweenContainer,
    DescriptionContainer,
    DescriptionText,
} from "./printReport.styled";

import logoFripickBlack from "@/assets/logoFripickBlack.svg";
import amountToFixed from "@/helper/amountToFixed";
import useGetUserInfoQuery from "../../hooks/queries/useGetUserInfoQuery";
import { newProviderPlatformReportService } from "@/api/constants";

export default function PrintCashReport({ setAlert, handleClose, show }) {
    const [receipt, setReceipt] = useState(null);
    const { data: userInfoRes } = useGetUserInfoQuery();
    const fetchReceipt = async () => {
        try {
            const dayStart = new Date();
            dayStart.setHours(0, 0, 0, 0);
            const response = await fetch(
                `${newProviderPlatformReportService}/cashReport/${userInfoRes?.data?.vendorId}?_=${dayStart.getTime()}`,
            );
            const data = await response.json();
            if (!data.cashReport?.providerName) {
                setAlert({ message: "No se han hecho ventas con cash o tarjeta" });
                handleClose();
                return;
            }
            setReceipt(data?.cashReport);
        } catch (error) {
            setAlert({ message: error?.message || "Ocurrió un error buscando los datos del reporte" });
            handleClose();
        }
    };

    useEffect(() => {
        if (show) {
            fetchReceipt();
        }
    }, [show]);
    useEffect(() => {
        if (receipt) {
            setTimeout(() => {
                window.print();
                handleClose();
            }, 20);
        }
    }, [receipt]);
    if (!receipt || !show) {
        return null;
    }

    return (
        <MainContainer>
            {receipt && (
                <>
                    <CenteringContainer>
                        <StyledTitle>Reporte de cierre</StyledTitle>
                    </CenteringContainer>

                    <DescriptionContainer>
                        <DescriptionText>
                            <div>Proveedor:</div>
                            <div>{receipt.providerName}</div>
                        </DescriptionText>
                        <SpaceBetweenContainer>
                            <DescriptionText>
                                <div>Fecha:</div>
                                <div>{receipt.date}</div>
                            </DescriptionText>
                            <DescriptionText>
                                <div>Hora:</div>
                                <div>{receipt.time}</div>
                            </DescriptionText>
                        </SpaceBetweenContainer>
                        <DescriptionText>
                            <div>Representante:</div>
                            <div>{receipt.vendorName}</div>
                        </DescriptionText>
                    </DescriptionContainer>

                    <TableContainer>
                        <TableFlexContainer>
                            <LeftFlexGrow>
                                <BoldDescriptionText>USUARIO</BoldDescriptionText>
                            </LeftFlexGrow>
                            <RightFlexGrow>
                                <BoldDescriptionText>TOTAL</BoldDescriptionText>
                            </RightFlexGrow>
                        </TableFlexContainer>

                        {receipt.usuarios?.map((detail) => (
                            <TableFlexContainer key={detail.userName}>
                                <LeftFlexGrow>
                                    <DescriptionText>{detail.userName}</DescriptionText>
                                </LeftFlexGrow>
                                <RightFlexGrow>
                                    <DescriptionText>{`RD$ ${amountToFixed(detail.total, 2)}`}</DescriptionText>
                                </RightFlexGrow>
                            </TableFlexContainer>
                        ))}
                    </TableContainer>
                    <DescriptionContainer>
                        <SpaceBetweenContainer>
                            <DescriptionText isBold={true}>
                                <div>Total</div>
                            </DescriptionText>
                            <DescriptionText>
                                <div>{`RD$ ${amountToFixed(receipt.total, 2)}`}</div>
                            </DescriptionText>
                        </SpaceBetweenContainer>
                    </DescriptionContainer>

                    <BottomCenteringContainer>
                        <Logo src={logoFripickBlack} />
                    </BottomCenteringContainer>
                </>
            )}
        </MainContainer>
    );
};